









import { Component, Vue } from 'vue-property-decorator'
import Login from '@/components/authentication/Login.vue'
import NavbarBlocked from '@/components/navbar/NavbarBlocked.vue'

@Component({
  components: {
  NavbarBlocked,
  Login,
  },
  })
export default class Logar extends Vue {}
